import { useQuery } from "@tanstack/react-query";
import { getScopeOfWork } from "../actions/getScopeOfWork";

interface Props {
  uid: string;
}

export function useScopeByUid({ uid }: Props) {
  return useQuery({
    queryKey: ["scopeOfWork", uid],
    queryFn: async () => {
      const res = await getScopeOfWork({ scopeOfWorkUid: uid });
      return res;
    },
    enabled: Boolean(uid),
    refetchOnWindowFocus: false,
  });
}


